<template>
<div>
  <br>

  
  <div ref = "map" class = "title is-size-2 title-font">
    Dónde estamos
  </div>
  

  
  <div class = "columns is-centered fix-white-margin-columns">
    <div class = "column is-10">
      <p class = "is-size-5"> Si prefiere información de primera mano acuda a nuestro taller situado en C/Austria, 7, Sanlúcar la Mayor, Sevilla. </p>

      <div class = "columns is-variable is-8 " style = "margin-right: -10px !important; ">
        <div class = "column">
          <figure class = "image" style = "margin: 1rem;">
            <img src = "../../public/fotos/12.jpg" />
          </figure>
        </div>
        <div class = "column">

          <div class = "columns is-mobile is-variable is-multiline is-3 fix-white-margin-columns" style = "margin: 0.5rem;">
            <div class = "column is-4">
              <figure class = "image">
                <img src = "../../public/fotos/12.jpg" />
              </figure>
            </div>
            <div class = "column is-4">
              <figure class = "image">
                <img src = "../../public/fotos/12.jpg" />
              </figure>
            </div>
            <div class = "column is-4">
              <figure class = "image">
                <img src = "../../public/fotos/12.jpg" />
              </figure>
            </div>
            <div class = "column is-8">
              <figure class = "image">
                <img src = "../../public/fotos/12.jpg" />
              </figure>
            </div>
            <div class = "column is-4">
              <div class = "columns is-multiline">
                <div class = "column is-12" style = "padding-bottom: 0.4rem;">
                  <figure class = "image">
                    <img src = "../../public/fotos/12.jpg" />
                  </figure>
                </div>
                <div class = "column is-12">
                  <figure class = "image">
                    <img src = "../../public/fotos/12.jpg" />
                  </figure>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
  

  
  <div class = "columns is-centered  fix-white-margin-columns" style = "margin-bottom: 1rem;">
    <div class = "column is-10">
      <div>
        <GmapMap ref="mapRef" :center="{lat:37.3796966, lng:-6.1990343}" :zoom="18" map-type-id="roadmap" style = "height:450px;">
          <gmap-marker
          :position="{lat:37.3796966, lng:-6.1990343}"
          @click="center={lat:37.3796966, lng:-6.1990343}"
        ></gmap-marker>
        </GmapMap>
      </div>
      
    </div>
  </div>
    


</div>
</template>

<script>

import {requester} from '../App.vue';
import _ from 'lodash';

export default {
  name: 'Map',
  data() {
    return { 
      name: "",
      email: "",
      message: "",
      messageSent: false
    }
  },
  methods: {
    currentYear: function(){
      let date = new Date();
      return date.getFullYear();
    },
    sendMessage: _.debounce(function(){

      let data = {
        name: this.name,
        email: this.email,
        message: this.message
      }

      requester.post('contact', data).then(() => {
        this.messageSent = true;
      }).catch( () => {
        
      })

    }, 200, {leading: true})
  },
  mounted() {
    /*this.$refs.mapRef.$mapPromise.then((map) => {
      map.panTo({lat: 1.38, lng: 103.80})
    })*/
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.title-font {
  font-family: "Baloo Bhaina 2";
}

h1, h2 {
  font-weight: normal;
}
div {
  text-align: center;
  font-family: 'Century Gothic', 'Tahoma', 'Verdana'
}
.footer {
  background-color: #222222;
}
.image.is-256x256 {
  height: 256px;
  width: 256px;
}

.square {
    float:left;
    position: relative;
    width: 23%;
    padding-bottom : 5%; /* = width for a 1:1 aspect ratio */
    margin:1.66%;
    background-position:center center;
    background-repeat:no-repeat;
    background-size:cover; /* you change this to "contain" if you don't want the images to be cropped */
}

.map-area {
  background-color: #B4D9ED;
}

.fix-white-margin-columns {
  /*margin-left: 0px !important;*/
  margin-right: 0px !important;
}
</style>
